import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";

import ContactBox from "../components/contact-box";
import TeamCarousel from "../components/team-carousel";

import EarthImage from "../images/earth.svg";


function updateAstronautLocation(event) {
  // document.getElementById("astronaut").style.left = event.clientX + "px";
  // document.getElementById("astronaut").style.top = event.clientY + "px";
}

const IndexPage = () => (
  <Layout hideNavigator >
    <SEO title="Home" />
    {/* The container has no role other than capturing mouse events for an animation */}
    {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
    <div className="container-fluid page about-us" onMouseMove={updateAstronautLocation}>
      <img className="earth-image" src={EarthImage} alt="Earth" />
      <TeamCarousel />
      <div className="spacer py-4" />
      <ContactBox />
    </div>
  </Layout>
)

export default IndexPage
